<template>
  <fragment>
    <mc-app-header title="Add Group">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="groups.submitting"
            type="is-primary"
            @click="addGroupHandler"
          >
            Add
          </b-button>
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="add-group section">
        <form class="mc-container">
          <b-field label="Name">
            <b-input
              v-model="newGroup.name"
              icon="format-title"
              placeholder="Group Name"
              type="text"
            />
          </b-field>
          <b-field label="Date Created">
            <mc-date-time
              v-model="newGroup.createdAt"
              placeholder="Click to select..."
              required
            >
            </mc-date-time>
          </b-field>
        </form>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Timestamp } from '../../firebase';

export default {
  data: function() {
    return {
      newGroup: {
        name: '',
        createdAt: Timestamp.now()
      }
    };
  },
  computed: {
    ...mapState(['groups'])
  },
  methods: {
    ...mapActions('groups', ['addGroup']),
    async addGroupHandler() {
      try {
        await this.addGroup({ ...this.newGroup });
        this.$buefy.toast.open({
          message: 'Group added successfully!',
          type: 'is-success'
        });
        this.$router.replace(`/groups`);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add group!',
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-group {
  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    .field {
      flex: 1 0 0;
      margin-bottom: 0;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }

  &__switch {
    display: flex;
    flex-direction: column;
  }
}
</style>
